export default __webpack_public_path__ + "static/media/le_touquet21.4878bb2f.jpg";